import { RootState } from "@/modules/common";

export const selectBasket = (state: RootState) => state.basket.basket;
